import { useTranslation } from 'react-i18next';

type ProfileStatsProps = {
  followersCount?: number;
  followingCount?: number;
  totalTrips: number;
  handicap?: number | string | null;
};

export function ProfileStats({ followersCount = 0, followingCount = 0, totalTrips, handicap = 0 }: ProfileStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-4 py-3 p-2">
      <div className="flex flex-col items-center">
        <div className="text-lg font-semibold">{handicap ? handicap : '-'}</div>
        <div className="text-xs text-primary">{t('golf_handicap')}</div>
      </div>
      <div className="border-l h-10 opacity-30"></div>
      <div className="flex flex-col items-center">
        <div className="text-lg font-semibold">{followersCount}</div>
        <div className="text-xs text-primary">{t('followers')}</div>
      </div>
      <div className="border-l h-10 opacity-30"></div>
      <div className="flex flex-col items-center">
        <div className="text-lg font-semibold">{followingCount}</div>
        <div className="text-xs text-primary">{t('following')}</div>
      </div>
      <div className="border-l h-10 opacity-30"></div>
      <div className="flex flex-col items-center">
        <div className="text-lg font-semibold">{totalTrips}</div>
        <div className="text-xs text-primary">{t('rounds')}</div>
      </div>
    </div>
  );
}
